export default {
  "iso3": "eng",
  "iso2": "en",
  "text": {
    "100200": "We're sorry, this game seems to be restricted in your area.",
    "GAME_SAVED_NOTIFICATION_TEXT": "Saved to profile!",
    "GAME_SAVED_NOTIFICATION_CTA": "See Items",
    "MY_SAVED_GAMES": "My Saved Games",
    "ALL": "ALL",
    "CURRENT_LANGUAGE": "English",
    "CIP8_TITLE": "888CASINO GAMES",
    "Login": "LOG IN",
    "WITHDRAW": "WITHDRAW",
    "CASHIER": "Cashier",
    "Search": "Search your game...",
    "REWARDS": "Rewards",
    "HOME": "Home",
    "888_COM": "888.com",
    "888_POKER": "poker",
    "888_CASINO": "casino",
    "888_BINGO": "bingo",
    "888_SPORT": "sport",
    "SIGN_UP": "SIGN UP",
    "DEPOSIT_SIDE_MENU": "Deposit",
    "MY_ACCOUNT": "My Account",
    "BALANCE": "Current Balance",
    "MINI_ORBIT_BALANCE": "Balance:",
    "LOGOUT": "Log out",
    "GREETING_MORNING": "Good Morning",
    "GREETING_AFTERNOON": "Good Afternoon",
    "GREETING_EVENING": "Good Evening",
    "GREETING_NIGHT": "Good Night",
    "GREETING_DEFAULT": "Hello",
    "MRS_TITLE": "Mrs.",
    "MR_TITLE": "Mr.",
    "SLOTS": "Slots",
    "LOBBY": "Lobby",
    "SLOTS_JACKPOTS": "Slots & Jackpots",
    "CARD_TABLE_GAMES": "Card & Table Games",
    "ALL_SDM_GAMES": "All SDM Games",
    "CASINO_GAMES": "Casino Games",
    "LIVE_CASINO": "Live Casino",
    "888_EXCLUSIVE_GAMES": "888 Exclusive Games",
    "PROMOTIONS": "Promotions",
    "888SPORT": "Sport",
    "VIP_CLUB": "VIP Club",
    "PWA_INSTALL": "Install App",
    "PWA_ADD_TO_HOME_SCREEN": "Add to Home Screen",
    "PWA_TAP": "Tap",
    "PWA_QUICK_LAUNCH": "Quick launch {BRAND}",
    "GETTING_STARTED": "Getting Started",
    "BANKING": "Banking",
    "VIP": "VIP",
    "BLOG": "Blog",
    "TODAY_WINNERS": "Today’s Winners",
    "SUPPORT_ID_MESSAGE": "Support ID",
    "DEPOSIT": "DEPOSIT",
    "CHOOSE_LANG": "Choose your language:",
    "CHOOSE_COUNTRY": "Choose your country:",
    "SIGN_IN_PLAY": "SIGN IN & PLAY",
    "NEW": "New",
    "JACKPOT": "Jackpot",
    "BRAND_EXCLUSIVE_FILTER": "{brandName} Exclusive",
    "EXCLUSIVE": "888 Exclusive",
    "SI_EXCLUSIVE": "SI Exclusive",
    "1-25_LINES": "1-25 lines",
    "25_PLUS_LINES": "25+ lines",
    "INFO_TITLE_ARENA_888_EXCLUSIVE_GAMES": "Exclusive Games",
    "INFO_TEXT_ARENA_888_EXCLUSIVE_GAMES": "888casino is home to an exclusive selection of online casino games. Play the hottest online slots from Section8, and enjoy fantastic casino games like online Roulette, online Blackjack and Video Poker. Our exclusive casino games also include Baccarat, Keno, and instant win games. Let’s get ready for some casino fun!",
    "INFO_TITLE_ARENA_SLOTS": "Online Slots",
    "INFO_TITLE_ARENA_VIDEO_SLOTS": "Video Slots",
    "INFO_TEXT_ARENA_SLOTS": "Choose from over 1000 of the best quality slot games, anywhere online. Enjoy a wide variety of features such as Bonus Games, Expanding Wilds, Free Spins and Huge Jackpots. Hunt for treasure in ancient Egypt, uncover the Leprechaun’s coveted pot o’ gold or spin for big wins on classic fruit machines. Whatever tickles your fancy, we’ve got it!",
    "INFO_TITLE_ARENA_CASINO": "Casino Games",
    "INFO_TEXT_ARENA_CASINO": "The cards are shuffled, the wheel is spinning and your seat is waiting. Play only the very best card and table games online. Choose from a variety of Roulette games including European, American, Low, High and Super Stakes. Prefer Blackjack? Play multiple hands at the same time. From Texas Hold’em to Caribbean, be sure to find your poker preference!",
    "INFO_TITLE_ARENA_ROULETTE": "Roulette Online",
    "INFO_TEXT_ARENA_ROULETTE": "Try to hit your lucky numbers at one of 888casino’s premier online roulette tables. Choose from our wide variety of top roulette game styles including European, American and French. Whether you’re a High Roller or prefer low stakes, there’s a roulette game for you. There’s nothing like the thrill of waiting for that ball to land when you play roulette!",
    "INFO_TITLE_ARENA_NEW_GAMES": "New Games",
    "INFO_TEXT_ARENA_NEW_GAMES": " ",
    "INFO_TITLE_ARENA_BLACKJACK": "Online Blackjack",
    "INFO_TEXT_ARENA_BLACKJACK": "The cards are shuffled and your seat is waiting for some of the best online blackjack games you’ll find! Play blackjack at 888casino on your own terms with Super Stakes, Side Bets and more. One hand of blackjack not enough for you? Play our Multihand Blackjack game for three chances to hit 21, at the same time!",
    "INFO_TITLE_ARENA_VIDEO_POKER": "Video Poker Online",
    "INFO_TEXT_ARENA_VIDEO_POKER": "If you think you’re a real poker pro then you’ve come to the right casino! Go for that elusive Royal Flush in our various types of video poker games. If you’re into 5-card draw or prefer the ever-popular Texas Hold’em then you’re sure to find your new favourite online video poker game at 888casino.",
    "INFO_TITLE_ARENA_SCRATCH_CARDS": "Scratch Cards Online",
    "INFO_TEXT_ARENA_SCRATCH_CARDS": "There’s nothing like a quick win on one of 888casino’s exciting scratch card games. Ideal for some strategy-free fun, pick an online scratch card in the theme of your choice. Reveal your Irish riches or discover pharaoh’s fortune, it’s up to you. Simply choose the amount you want to bet and see if you’re a scratch card winner!",
    "INFO_TITLE_ARENA_JACKPOTS": "Jackpots",
    "INFO_TEXT_ARENA_JACKPOTS": "Jackpot games are bubbling over with unbelievably huge cash prizes. Play with our slots games and you’re in lots of joy and fun. These include daily jackpots, progressive jackpots, and pooled jackpots, you are one click away from the absolute perfect play; enjoy jackpot slots games like Millionaire Genie, Mermaid’s Millions, or Noche De Los Muertos. Click it to pick it. Spin it to try your luck to win it. The fun starts NOW!",
    "INFO_TITLE_ARENA_ALL_GAMES": "All Games",
    "VIRTUAL_SPORTS": "Virtual Sports",
    "INFO_TITLE_ARENA_VIRTUAL_SPORTS": "Virtual Sports",
    "INFO_TEXT_ARENA_VIRTUAL_SPORTS": "Virtual Sports brings you a wide variety of computer-generated sports games that you’ll be able to bet on. So, whether football's your thing, or darts, or anything else, you can be sure to find what you're looking for. Enter the world of virtual betting today.",
    "PROMO_ELIGIBLE_GAMES": "Promo Eligible Games",
    "BONUS": "Bonus",
    "FREE_SPINS": "Free Spins",
    "CLEAR_ALL": "Clear All",
    "FILTER": "Filter",
    "APPLY": "Apply",
    "ROULETTE": "Roulette",
    "ELITE_LOUNGE": "Elite Lounge",
    "BLACKJACK": "Blackjack",
    "PROGRESSIVE_SLOTS": "Progressive Slots",
    "BACCARAT": "Baccarat",
    "POKER": "Poker",
    "KENO": "Keno",
    "CRAPS": "Craps",
    "HIGH_LIMIT": "High Limit",
    "LANGUAGES": "Languages",
    "HELP": "Help",
    "LIVE_CHAT": "Live Chat",
    "DEMO": "Demo",
    "PLAY": "Play",
    "NOT_NOW": "Not now",
    "MAYBE_LATER": "Maybe later",
    "NO_THANKS": "No, thanks",
    "LETS_PLAY": "Let's Play!",
    "GOT_IT": "GOT IT!",
    "LIMITS": "Limits",
    "LIVE": "Live",
    "SEE_ALL": "See All",
    "WINNING_IN_THE_LAST_30_DAYS": "Winning in the last 30 days",
    "TOTAL_JACKPOTS": "Total Jackpots",
    "TOP_GAMES": "TOP SLOT GAMES",
    "TOP_PROGRESSIVES": "TOP PROGRESSIVES",
    "LIVE_CASINO_TABLES": "SELECTED LIVE TABLES",
    "TOP_CASINO_GAMES": "TOP CASINO GAMES",
    "JACKPOTS": "JACKPOTS",
    "RECENTLY_PLAYED": "Recently Played",
    "BECAUSE_YOU_PLAYED": "Because You Played {gameName}",
    "MINIMUM_BET": "Min Bet",
    "MAXIMUM_BET": "Max Bet",
    "PAYLINES": "Paylines",
    "BONUS_GAME": "Bonus game",
    "MAX_PER_SPOT": "Max Per Spot",
    "MULTIPLAYER": "Multiplayer",
    "DECKS": "Decks",
    "SIDE_BETS": "Side Bets",
    "ABOUT": "About",
    "GAME_JACKPOT": "Game Jackpot",
    "SLOT_GAMES": "Slot Games",
    "CARD_AND_TABLE_GAMES": "Card & Table Games",
    "JACKPOT_GAMES": "Jackpot Games",
    "JACKPOT_CENTRAL": "Jackpot Central",
    "OTHER": "Other",
    "POKER_GAMES": "Poker Games",
    "YOUR_SEARCH_DID_NOT_MATCH_ANY_GAMES": "Your search did not match any games",
    "PREMIER_ONLINE_LIVE_CASINO": "Premier live casino",
    "All_SLOTS": "All Slots",
    "All_CARD_AND_TABLE_GAMES": "All Card & Table Games",
    "USEFUL_LINKS": "Useful links",
    "PRIVACY_POLICY": "Privacy Policy",
    "USER_AGREEMENT": "User Agreement",
    "RESPONSIBLE_GAMBLING": "Responsible Gambling",
    "SAFE_ZONE": "Control Center",
    "CONTACT": "Contact Us",
    "COMP_POINTS": "Comp Points",
    "HISTORY": "History",
    "GAMING_HISTORY": "Gaming History",
    "JACKPOT_BET_HISTORY": "Jackpot Bet History",
    "TIPPING_HISTORY": "Tipping History",
    "TIPPING_HISTORY_AMOUNT": "Tip Amount",
    "CASHIER_HISTORY": "Cashier History",
    "GAMING_SESSION_HISTORY": "Session History",
    "MY_CHALLENGES": "My Challenges",
    "SCRATCHCARDS": "Scratch cards",
    "QUICK_LINKS_TITLE": "QUICK LINKS",
    "NO_SEARCH_RESULTS": "No Search Results Found...",
    "SEARCH_YOUR_GAME": "Find Games, Themes, Studios",
    "SEARCH_RESULTS_TITLE": "TOP SEARCH RESULTS",
    "SUGGESTED_GAMES": "SUGGESTED GAMES",
    "SUGGESTED_CATEGORIES": "SUGGESTED CATEGORIES",
    "BACK": "Back",
    "HIT_THE_JACKPOT": "Hit The Jackpot",
    "OUR_JACKPOTS": "OUR JACKPOTS",
    "MY_CLUB": "My Club",
    "LOW_ROLLERS": "Low Rollers",
    "CASH_BALANCE": "Cash",
    "BONUS_BALANCE": "Bonus",
    "YOU_MAY_LIKE": "YOU MAY LIKE",
    "TOP_PICKS_FOR": "TOP PICKS FOR {USERNAME}",
    "888CLUB": "888club",
    "888POKER": "Poker",
    "BACK_TO_888POKER": "Back to 888poker",
    "BACK_TO_888SPORT": "Back to 888sport",
    "VIDEO_POKER_GAMES": "Video Poker Games",
    "VIDEO_POKER": "Video Poker",
    "SEO_IMAGE_CATEGORIES_TITLE": "Best {categoryName} experience at 888casino",
    "SEO_IMAGE_CATEGORIES_ALT": "online casino - {categoryName}",
    "SEO_IMAGE_GAME_TITLE": "{gameName} {categoryName}",
    "PLAY_50_FREESPINS": "PLAY 50 FREESPINS",
    "HOLIDAY_GAMES": "HOLIDAY GAMES",
    "ORIGINALS": "888 Originals",
    "RELATED_GAMES": "BECAUSE YOU PICKED: {gameName}",
    "DAILY_JACKPOT_GAMES": "Daily Jackpot Games",
    "TOP_EXCLUSIVE_SLOTS": "Top Exclusive Slots",
    "TOP_10_IN_YOUR_COUNTRY": "Top 10 in your country",
    "NEW_GAMES_LIST_TITLE": "New Online Casino Games",
    "NEW_GAMES": "New Games",
    "DAILY_JACKPOT": "Daily Jackpot",
    "PROGRESSIVE_JACKPOT": "Progressive Jackpot",
    "777_JUKEBOX": "777 Jukebox",
    "RETRO_SLOTS": "Retro Slots",
    "SELECTED_LIVE_CASINO_TABLES": "Selected Live Casino Tables",
    "BLACKJACK_GAMES": "Blackjack Games",
    "ROULETTE_GAMES": "Roulette Games",
    "DROP_THE_JACKPOT": "Drop The Jackpot",
    "777_LIVE": "777 Live",
    "ROULETTE_&_BLACKJACK": "Roulette & Blackjack",
    "SCRATCH_CARDS": "Scratch Cards",
    "CLASSIC_SLOTS": "Classic Slots",
    "777_FAVORITES": "777 Favorites",
    "FEATURED": "Featured",
    "LOW_VOLATILITY": "Low Volatility",
    "HIGH_VOLATILITY": "High Volatility",
    "IN_HOUSE_SLOTS": "In House Slots",
    "MORE_GAMES": "More Games",
    "ALL_JACKPOTS": "All Jackpots",
    "ONLINE_JACKPOTS": "Online Jackpots",
    "All_GAMES": "All Games",
    "POPULAR_GAMES_TITLE": "Popular Games",
    "MORE": "More",
    "HOMEPAGE-SPOOKY_SPINS": "Spooky Spins",
    "THE_DAILY_JACKPOT": "888 Daily Jackpot",
    "HIGH_NOON_JACKPOT": "High Noon Jackpot",
    "TWILIGHT_JACKPOT": "Twilight Jackpot",
    "POWER8_JACKPOT": "POWER 8 JACKPOT",
    "RED_TIGER_DAILY_JACKPOT": "Red Tiger's Daily Jackpot",
    "RED_TIGER_HOURLY_JACKPOT": "Red Tiger Hourly Jackpot",
    "PROGRESSIVE_JACKPOTS": "Progressive Jackpots",
    "INSTANT_GAMES": "Instant Win Games",
    "INSTANT_WIN_GAMES_ARENA": "Instant Win Games",
    "ALL_INSTANT_WIN_GAMES": "All Instant Win Games",
    "INFO_TITLE_ARENA_INSTANT_WIN_GAMES": "Instant Win Games",
    "INFO_TEXT_ARENA_INSTANT_WIN_GAMES": "Instant Win Games are so much FUN! Get ready to scratch & match with the best scratch cards under the sun. We’ve got many games for you to enjoy like Volcano Eruption, Panda Mania, and Merlin’s Millions. Short on time? No worries, try our Keno and Bingo games, or sizzling-hot new games like Chicken Extreme, 7-UP, and Epic Gems. It’s a party and you’re invited. Instant Win Games are really easy to play. No skills needed – just play & win!",
    "MEGAWAYS_TITLE": "Megaways™",
    "TRENDING_SLOTS": "TRENDING SLOTS",
    "EXCLUSIVE_LIVE_TABLES": "EXCLUSIVE LIVE TABLES",
    "BLACKJACK_AND_ROULETTE_GAMES": "BLACKJACK & ROULETTE GAMES",
    "ALL_888_EXCLUSIVE_GAMES": "ALL 888 EXCLUSIVE GAMES",
    "LIVE_ARENA_TABLE_IS_CLOSED_MESSAGE": "Table Opens at",
    "LIVE_CASINO_TABLE_FULL_PC": "Table Full",
    "LIVE_CASINO_TABLE_FULL_MOBILE": "Full",
    "GAME_SHOWS": "Game Shows",
    "TOP_EVO_GAMES": "Top Games",
    "FOR_YOU_GAMES": "For You",
    "AB_TEST_AI_LIST_TITLE_D1_V1": "Top Rated Games for {USERNAME}",
    "AB_TEST_AI_LIST_TITLE_D1_V2": "Recommended games for {USERNAME}",
    "AB_TEST_AI_LIST_TITLE_D3_V1": "Selected Games for {USERNAME}",
    "AB_TEST_AI_LIST_TITLE_D3_V2": "Chosen Games for {USERNAME}",
    "AB_TEST_AI_LIST_TITLE_D3_V3": "Exclusive games for {USERNAME}",
    "AB_TEST_AI_LIST_TITLE_D3_V4": "Recommended games for you",
    "LETS_PLAY_MONOPOLY": "Let's play Monopoly",
    "TOP_TRENDING_SLOTS": "Top Trending Slots",
    "TOP_PAYING_SLOTS": "Top Paying Slots",
    "RECENTLY_ADDED": "Recently Added",
    "TOP_SLOTS": "Top Slots",
    "REAL_MONEY_GAME": "This game can be played with cash balance only.",
    "CANT_CONNECT_ERROR_TITLE": "Can't connect",
    "CANT_CONNECT_ERROR_MESSAGE": "Sorry, something went wrong on our end.",
    "RETRY": "Retry",
    "TRANSACTION_HISTORY": "Transaction History",
    "UPLOAD_DOCUMENTS": "Upload Documents",
    "BRAND_NEW": "Brand New",
    "HOTTEST_NEW_GAMES": "Hottest new games",
    "SINCE_LAST_MONTH": "Since Last Month",
    "FROM_LAST_MONTH": "From Last Month",
    "SAFE_GAMBLING_TOOLTIP": "Safer Gambling Tools & Information",
    "PLAYER_LIMITS_TOASTER_TITLE": "Your Limits",
    "PLAYER_LIMITS_TOASTER_DAILY_LABEL": "Daily",
    "PLAYER_LIMITS_TOASTER_WEEKLY_LABEL": "Weekly",
    "PLAYER_LIMITS_TOASTER_MONTHLY_LABEL": "Monthly",
    "PLAYER_LIMITS_TOASTER_DEPOSIT_LABEL": "Deposit",
    "PLAYER_LIMITS_TOASTER_PLAY_TIME_LABEL": "Play Time",
    "PLAYER_LIMITS_TOASTER_BANKROLL_LABEL": "Bankroll",
    "PLAYER_LIMITS_TOASTER_HOUR_LABEL": "hour",
    "GAME_POPUP_TITLE": "Welcome back",
    "GAME_POPUP_SUB_TITLE": "Suggested game",
    "GAME_POPUP_DESCRIPTION": "Your 888slots activity:",
    "GAME_POPUP_GAME_UNAVAILABLE": "Sorry, this game is unavailable",
    "GAME_POPUP_MAY_LIKE": "You may also like",
    "PARTY_JACKPOT_WELCOME_POPUP_TITLE": "HOORAY! You’re about to play a {partyJackpotName} game!",
    "PARTY_JACKPOT_WELCOME_POPUP_TITLE_ALL_LIVE_CASINO": "LUCKY YOU!",
    "PARTY_JACKPOT_WELCOME_POPUP_SUB_TITLE_ALL_LIVE_CASINO": "All Live Casino games are part of our HOT NEW jackpot!",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION": "The Jackpot can be won on any cash balance bet.\nAll Party Jackpot prizes are bonuses, which are instantly credited to your account.",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL": "Any real money bet on a Party Jackpot game could win a cash prize!\nThe Party Jackpot will pay daily!",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL_HOURLY": "Any real money bet on a Party Jackpot game could win a cash prize!\nThe Party Jackpot will pay hourly between {startHour} to {endHour}",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL_HOURLY_ALL_LIVE_CASINO": "Real money bets on any Live Casino game could win the jackpot!\nThe Live Casino Jackpot must pay every hour, {startHour} - {endHour}, and is fully funded by us.",
    "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE": "Bonus: wager 30x (varies by game type), 90 day expiry, wins capped at $500, valid for selected games",
    "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE_REAL": "Funded players only",
    "PARTY_JACKPOT_WELCOME_POPUP_TERMS_AND_CONDITIONS_APPLY": "T&C Apply.",
    "PARTY_JACKPOT_WIN_TOASTER_TITLE": "The {jackpotName} just dropped at {winAmount}!",
    "PARTY_JACKPOT_WIN_TOASTER_SUBTITLE": "Didn’t win? No worries!\n This jackpot drops every hour, {startHour}-{endHour}.",
    "PARTY_JACKPOT_WIN_POPUP_YOU_WON": "YOU WON THE {jackpotName}",
    "PARTY_JACKPOT_WIN_POPUP_AWESOME": "AWESOME!",
    "PARTY_JACKPOT_OUT_OF_CASH_TOASTER_TITLE": "Top up to play the Live Casino Jackpot",
    "PARTY_JACKPOT_OUT_OF_CASH_TOASTER_SUBTITLE": "The Live Casino Jackpot can only be won with real money",
    "JACKPOT-WIDGET-MUST-PAY": "Must Pay within:",
    "JACKPOT-WIDGET-DROPS-SOON": "DROPS SOON!",
    "JACKPOT-WIDGET-NEXT-JACKPOT": "Launching Next Jackpot",
    "JACKPOT-WIDGET-LAST-WIN": "Last win",
    "IN-GAME-WIDGET-STARTS-SOON": "Starts Soon",
    "FREEPLAY_INDICATOR": "FreePlay",
    "OMG_INDICATOR": "Notifications",
    "USER_LIKE_YOU": "TOP {topNumber} IN {countryName}",
    "YOUR_COUNTRY": "Your country",
    "SOURCE_OF_FUNDS_TITLE": "Important Info Needed",
    "SOURCE_OF_FUNDS_MESSAGE1": "Hi, welcome back!",
    "SOURCE_OF_FUNDS_MESSAGE2": "We just need some info from you. It won't take long at all!",
    "SOURCE_OF_FUNDS_OPEN_CHAT_BTN": "LET'S CHAT",
    "CLOSE": "Close",
    "LIVE_STREAM_WATCH_TIME_REACHED": "Ready to dive in and play?",
    "LIVE_STREAM_VIDEO_LOADING": "Loading…",
    "PLAY_NOW": "PLAY NOW",
    "CASINO": "CASINO",
    "UK_TSR_CONTINUE_OPT": "Continue",
    "UK_TSR_REVIEW_REMINDERS_OPT": "Review reminders",
    "UK_TSR_LOGOUT_OPT": "Logout",
    "UK_TSR_RESUME_GAME_OPT": "Resume Game",
    "UK_TSR_STOP_REMINDERS_OPT": "Stop all game time reminders",
    "UK_TSR_HISTORY_OPT": "View History",
    "UK_TSR_CLOSE_GAME_OPT": "Close Game",
    "TSR_SUBTEXT": "What would you like to do?",
    "PAYMENTS_REDIRECT_FOCUS_TITLE": "Deposit in process",
    "PAYMENTS_REDIRECT_FOCUS_TEXT": "Your {mftName} screen is still open",
    "PAYMENTS_REDIRECT_FOCUS_CTA": "Continue",
    "VOLATILE_SLOTS": "Volatile Slots",
    "VOLATILE_GAMES": "Volatile Games",
    "HIGH_VOLATILITY_SLOTS": "High Volatility Slots",
    "LOW_VOLATILITY_SLOTS": "Low Volatility Slots",
    "STATE_POPUP_TITLE": "Verify Your Location",
    "STATE_POPUP_HEADER": "Please confirm that you're located in {THE_STATE}",
    "STATE_POPUP_OUTSIDE_TEXT": "I'm located outside of {THE_STATE}",
    "STATE_POPUP_CONFIRM": "Confirm",
    "BURNOUT_MESSAGE_LINE_1": "SURPRISE!",
    "BURNOUT_MESSAGE_LINE_2": "YOU GOT A BONUS!",
    "CONGRATS": "Congrats!",
    "YOUR_FP_ARE_WAITING": "Your FreePlay are waiting for you here",
    "EXIT_POPUP_TITLE": "We thought you’d like",
    "DONT_SHOW_AGAIN_TEXT": "Don't show again",
    "DAILY_DEAL_WIDGET_STRIP": "I GIORNALIERI",
    "GAMING_HISTORY_NO_RECORDS": "We were unable to locate any history records of your games",
    "GAMING_HISTORY_LAST_PAGE": "No more history records found.",
    "GAMING_HISTORY_BET": "Bet",
    "GAMING_HISTORY_WINNINGS": "Winnings",
    "GAMING_HISTORY_WINNINGS_BONUS_CAP": "Winnings*",
    "GAMING_HISTORY_BANKROLL": "Bankroll",
    "GAMING_HISTORY_MORE_DETAILS": "More Details",
    "GAMING_HISTORY_MORE_DETAILS_NOT_AVAILABLE_PC": "Available only on Mobile devices",
    "GAMING_HISTORY_MORE_DETAILS_NOT_AVAILABLE_MOBILE": "Available only on PC",
    "GAMING_HISTORY_FREE_PLAY_BET": "Bet*",
    "GAMING_HISTORY_FREE_PLAY_WINNINGS": "Winnings*",
    "GAMING_HISTORY_FREE_PLAY_REWARD_WINNINGS": "Reward winnings",
    "GAMING_HISTORY_FREE_PLAY_REWARD_BANKROLL": "Reward bankroll",
    "GAMING_HISTORY_FREE_PLAY_INDICATION": "*Played with rewards",
    "GAMING_HISTORY_FREE_PLAY_MAX_CUP_INDICATION": "*Maximum win",
    "GAMING_HISTORY_BIG_WIN_TAX_INDICATION": "Pending IRS form W-2G completion",
    "GAMING_HISTORY_DAYS_INTERVAL": "Last {numberOfDays} Days",
    "GAME_PARTICIPATION_ID": "Participation ID: {participationID}",
    "GAME_SESSION_ID": "Session ID: {sessionID}",
    "HISTORY_GAME_SESSION_TOTAL_BETS": "Total bets",
    "HISTORY_GAME_SESSION_TOTAL_WINNINGS": "Total wins",
    "HISTORY_GAME_SESSION_BALANCE": "Session Balance",
    "FILTER_GROUP_VENDOR_TYPE": "Vendor Name",
    "GAME_WINDOW_VENDOR_SESSION_ID": "Session ID: {sessionID}",
    "GAME_WINDOW_MODE_REAL_LABEL": "Real Money",
    "GAME_WINDOW_MODE_DEMO_LABEL": "Demo",
    "FREE_PLAY_VOUCHER_NAME_FPV": "FreePlay",
    "FREE_PLAY_VOUCHER_NAME_FSV": "Free Spins",
    "FREE_PLAY_VOUCHER_NAME_JPFPV": "Jackpot FreePlay",
    "FREE_PLAY_VOUCHER_NAME_JPFSV": "Jackpot Spins",
    "FREE_PLAY_VOUCHER_BALANCE_PREFIX": "Remaining:",
    "FREE_PLAY_VOUCHER_TITLE_FPV": "FreePlay Reward",
    "FREE_PLAY_VOUCHER_TITLE_FSV": "Free Spins Reward",
    "FREE_PLAY_VOUCHER_TITLE_JPFPV": "Jackpot FreePlay Reward",
    "FREE_PLAY_VOUCHER_TITLE_JPFSV": "Jackpot Spins Reward",
    "FREE_PLAY_VOUCHER_DESC_FPV": "Free play money to use on selected games in whichever way you wish!",
    "FREE_PLAY_VOUCHER_DESC_FSV": "Free Spins with pre-defined values to use on selected games!",
    "FREE_PLAY_VOUCHER_DESC_JPFPV": "Jackpot-only FreePlay money to use on selected games in whichever way you wish!",
    "FREE_PLAY_VOUCHER_DESC_JPFSV": "Jackpot-only Free Spins with pre-defined values to use on selected games!",
    "FREE_PLAY_VOUCHER_REWARD_AMOUNT": "{amount} {fp_voucher_name}",
    "FREE_PLAY_VOUCHER_REWARD_BALANCE": "{fp_voucher_remaining_prefix} {balance}",
    "FREE_PLAY_EXPIRES_IN_TIME": "Expires in {expiration}",
    "FREE_PLAY_EXPIRES_IN_EXPIRED": "Expired",
    "FREE_PLAY_EXPIRES_IN_DAY": "Expires in {expiration} days",
    "FREE_PLAY_MESSAGE_VOUCHER_TITLE_GOOD_LUCK": "Good Luck!",
    "FREE_PLAY_MESSAGE_LIST_TITLE": "You have rewards waiting for you. Good Luck!",
    "FREE_PLAY_MESSAGE_SELECTED_GAME_TITLE": "This game can also be played with the following rewards:",
    "FREE_PLAY_MESSAGE_GAMES_LIST_TITLE": "You can use this reward in the game(s) below.",
    "FREE_PLAY_MESSAGE_NO_VOUCHERS": "You have no rewards available",
    "FREE_PLAY_MESSAGE_BACK_TO_VOUCHERS": "Back",
    "FREE_PLAY_SHOW_MORE": "Show More",
    "FREE_PLAY_SHOW_LESS": "Show Less",
    "FREE_PLAY_USE_NOW_BUTTON": "Use Now",
    "FREE_PLAY_USE_LATER_BUTTON": "Use Later",
    "FREE_PLAY_SUGGESTION_DIALOG_TITLE": "You have rewards in this game!",
    "IDLE_RECOMMENDATIONS_TITLE": "Looking for your next game?",
    "IDLE_RECOMMENDATIONS_SECOND_TITLE": "What about",
    "BONUS_ABUSE_PREVENTION_TITLE": "Disconnected Game",
    "BONUS_ABUSE_PREVENTION_MESSAGE": "It looks like there's a game that was disconnected... Please complete {gameName} before you can start playing {newGameName}.",
    "BONUS_ABUSE_PREVENTION_NOT_NOW_BTN": "Not Now",
    "BONUS_ABUSE_PREVENTION_COMPLETE_BTN": "Complete Game",
    "OPEN_GAME_FROM_CHALLENGES": "Challenges can’t be completed using rewards.",
    "CANCEL": "Cancel",
    "YES": "Yes",
    "NO": "No",
    "ONE_GAME_PER_SESSION_DIALOG_TITLE": "Open Game",
    "ONE_GAME_PER_SESSION_DIALOG_MESSAGE": "It looks like there's a game that's still open....\nWould you like to close {oldGameName} and start playing {newGameName}?",
    "GAMES_OF_THE_WEEK": "Games Of The Week",
    "THE_FISH_MARKET": "The Fish Market",
    "LETS_PLAY_POKER": "Lets Play Poker!",
    "HYBRID_EMBEDDED_GAME_LOADING_SLOW_CONNECTION_TOASTER_TITLE": "Slow connection",
    "HYBRID_EMBEDDED_GAME_LOADING_SLOW_CONNECTION_TOASTER_SUBTITLE": "We've detected a slow network connection. Opening the game may take a little longer than expected.",
    "HYBRID_EMBEDDED_GAME_LOADING_SPINNER_LABEL": "Connecting...",
    "HYBRID_EMBEDDED_GAME_LOADING_PACKAGES_PROGRESS": "Preparing game {packagesStatus}",
    "HELP_CENTER": "Help Centre",
    "GEO_PERMISSIONS_POPUP_TITLE": "Location Check",
    "GEO_PERMISSIONS_POPUP_TOP_TEXT": "Allow location verification",
    "GEO_PERMISSIONS_POPUP_MIDDLE_TEXT": "We need your location to verify that playing is allowed in your province",
    "GEO_PERMISSIONS_BUTTON": "OK",
    "ABOUT_HELP_SUPPORT": "For any support queries, please visit our online help",
    "ABOUT_TITLE": "Your Account Details",
    "ABOUT_FISCAL_CODE_TITLE": "Fiscal Code",
    "ABOUT_SUPPORT_ID_TITLE": "ID for support",
    "ABOUT_CLIENT_VERSION_TITLE": "Client Version",
    "ABOUT_OPEN_SESSION_TITLE": "Open session balance",
    "GEO_PLUGIN_INSTALLATION_MSG_TITLE": "Location check",
    "GEO_PLUGIN_INSTALLATION_MSG_HEADER_1": "Verify Your Location.",
    "GEO_PLUGIN_INSTALLATION_MSG_HEADER_2": "This site is dedicated for players in USA permitted states.",
    "GEO_PLUGIN_INSTALLATION_MSG_HEADER_3": "To verify your location and start playing, please install the",
    "GEO_PLUGIN_INSTALLATION_MSG_HEADER_4": "GeoComply plugin:",
    "GEO_PLUGIN_INSTALLATION_MSG_BODY_1": "Click the Download Plugin button below",
    "GEO_PLUGIN_INSTALLATION_MSG_BODY_2": "Open the file from the download bar",
    "GEO_PLUGIN_INSTALLATION_MSG_BODY_3": "Click Run to install the file",
    "GEO_PLUGIN_INSTALLATION_MSG_FOOTER": "Need to redownload the plugin?",
    "GEO_PLUGIN_DOWNLOAD_BUTTON": "DOWNLOAD",
    "GEO_FREEZE_POPUP_TOP_TEXT": "We're confirming your location.",
    "GEO_FREEZE_POPUP_MIDDLE_TEXT": "It should only take a few seconds. This window will close automatically after confirmation.",
    "GEO_DIALOG_STANDARD_TITLE": "Location Verification",
    "GEO_GAME_RESTRICTION_TOP_TEXT": "Verify your location",
    "GEO_GAME_RESTRICTION_MIDDLE_TEXT": "That action requires location verification. To verify your location, please log out and retry. If the problem persists, please contact us.",
    "GEO_RETRY_GAME_RESTRICTION_MIDDLE_TEXT": "That action requires location verification. To verify your location please retry. If the problem persists, please contact us.",
    "ENFORCE_HYBRID_APP_TITLE": "Download the app",
    "ENFORCE_HYBRID_APP_TEXT": "To log in from your mobile device please download the app.",
    "ENFORCE_HYBRID_APP_CONTINUE_BUTTON": "GET THE APP",
    "ONE_HOUR": "1 hour",
    "X_HOURS": "{x} hours",
    "ONE_MINUTE": "1 minute",
    "X_MINUTES": "{x} minutes",
    "ONE_DAY": "1 day",
    "X_DAYS": "{x} days",
    "ONE_WEEK": "1 week",
    "ONE_MONTH": "1 month",
    "SELECT": "Please select",
    "DONT_WANT_TO_BE_BLOCKED": "I don't want to be blocked",
    "GAMBLING_SESSION_SETUP_TITLE": "Start your session",
    "GAMBLING_SESSION_MESSAGE": "Note: The session applies to all Casino games and Poker Cash games only",
    "GAMBLING_SESSION_WARN_MESSAGE": "LIMITS ARE RESET ONCE REACHED OR UPON RE-LOGIN",
    "GAMBLING_SESSION_START": "Start Session",
    "GAMBLING_SESSION_LAST_BET": "Last bet: {lastBetDate}",
    "GAMBLING_SESSION_TIME_LIMIT_REQUIRED_ERROR": "Session Time Limit not set",
    "GAMBLING_SESSION_LOSS_LIMIT_REQUIRED_ERROR": "Session Loss Limit not set",
    "GAMBLING_SESSION_LIMIT_REGULATORY_TEXT": "We support and promote {responsibleGamblingLink} and make available the tools to support sustainable play. Excessive gambling can have a negative effect on your life, leading to addiction, financial difficulties and breakdown of relationships.",
    "GAMBLING_SESSION_LIMIT_RESPONSIBLE_GAMING_LINK": "safer gambling",
    "GAMBLING_SESSION_REMINDER_INTERVAL_DROP_DOWN_LABEL": "Session Reminders",
    "GAMBLING_SESSION_LOSS_LIMIT_VALUE": "{percent}% of bankroll ({loss})",
    "GAMBLING_SESSION_LOSS_LIMIT_DROP_DOWN_LABEL": "Session Loss limit",
    "GAMBLING_SESSION_LIMIT_RESTRICTION_PERIOD_VALUE": "Be blocked for {time}",
    "GAMBLING_SESSION_LIMIT_RESTRICTION_BLOCK_CONFIRMATION_TEXT": "You have chosen to be blocked for {time}. This means that once your game session ends, you will not be able to play again for the time period you have selected.",
    "GAMBLING_SESSION_LIMIT_RESTRICTION_BLOCK_CONFIRMATION_QUESTION": "Are you sure?",
    "GAMBLING_SESSION_RESTRICTION_PERIOD_DROP_DOWN_LABEL": "When my session ends",
    "GAMBLING_SESSION_LIMIT_TIME_LOSS_CONFIRMATION_TEXT": "Note that you have set your maximum playing time at {time}.",
    "GAMBLING_SESSION_LIMIT_TIME_LOSS_CONFIRMATION_QUESTION": "Do you want to continue?",
    "GAMBLING_SESSION_TIME_LIMIT_DROP_DOWN_LABEL": "Session Time Limit",
    "GAMBLING_SESSION_TIME_LIMIT_REACHED_TITLE": "Time limit reached",
    "GAMBLING_SESSION_LOSS_LIMIT_REACHED_TITLE": "Loss limit reached",
    "GAMBLING_SESSION_INTERVAL_REMINDER_TITLE": "Game Time Reminders",
    "GAMBLING_SESSION_TIME_LIMIT_REACHED_TEXT": "At {gamblingSessionLimitTimestamp} you have reached your time limit in this session",
    "GAMBLING_SESSION_LOSS_LIMIT_REACHED_TEXT": "At {gamblingSessionLimitTimestamp} you have reached your loss limit in this session",
    "GAMBLING_SESSION_INTERVAL_REMINDER_TEXT": "At {gamblingSessionLimitTimestamp} you have reached your Game Time Reminders in this session.",
    "GAMBLING_SESSION_DATA_DURATION": "Session Duration:",
    "GAMBLING_SESSION_DATA_WIN_LOSS_SUMMARY": "Win / Loss Summary:",
    "GAMBLING_SESSION_DATA_TOTAL_BETS": "Total bets:",
    "GAMBLING_SESSION_ADVANCED_WARN_LOSS_LIMIT_TOAST": "Your Loss Limit is about to be reached",
    "GAMBLING_SESSION_ADVANCED_WARN_TIME_LIMIT_TOAST": "Your Time Limit is about to be reached",
    "GAMBLING_SESSION_LOGOUT_DIALOG_TITLE": "Logout. Session summary",
    "GAMBLING_SESSION_SELF_RESTRICTION_MESSAGE": "You have imposed a restriction on yourself to play additional casino games until {restrictionExpirationDate}.",
    "GAMBLING_SESSION_LIMITS_ALREADY_SET": "Session limits already set",
    "ATTENTION": "Attention!",
    "TOTAL_BANKROLL": "Full Bankroll:",
    "GAME_SESSION_BALANCE": "Session balance:",
    "TOTAL_WINS": "Total win amounts:",
    "TOTAL_BETS": "Total bet amounts:",
    "GAME_SESSION_SUMMARY_DIALOG_TITLE": "Session has ended",
    "GAME_SESSION_SUMMARY_DIALOG_MESSAGE": "Your session for {game_name} has ended\n\nTotal bets {total_bets_amount}\n\nTotal wins {total_wins_amount}",
    "OK": "OK",
    "NJ_LOGOUT_MESSAGE_TITLE": "Logout",
    "NJ_LOGOUT_MESSAGE_TEXT": "If you or someone you know has a gambling problem and wants help,\ncall 1-800-Gambler.",
    "INSUFFICIENT_FUNDS_TITLE": "Insufficient balance",
    "INSUFFICIENT_FUNDS_MESSAGE": "Your current balance is not sufficient for this game. To continue playing, you must first make a deposit to the cashier.",
    "OPEN_CASHIER": "Open Cashier",
    "GAME_LIMIT_REAL_MONEY_WARNING_MESSAGE": "This game can be played with cash balance only.",
    "SUGGEST_REAL_MODE_DIALOG_TITLE": "Demo Game",
    "SUGGEST_REAL_MODE_DIALOG_TEXT": "Please note that {game_name} will be opened in demo mode.<br><br>To play in real money mode, please register or log in.",
    "PLAY_DEMO": "Play Demo",
    "GAME_NET_POSITION_LABEL": "Game Balance",
    "GAME_DURATION_LABEL": "Game Duration",
    "GAME_LIMIT_TITLE": "Choose the money in the game",
    "REGULATORY_LIMIT_LABEL": "Regulatory limit",
    "OTHER_LIMIT_LABEL": "Other",
    "GAME_LIMIT_INSUFFICIENT_FUNDS": "Amount is more than the total available",
    "GAME_LIMIT_VALUE_ERROR": "Invalid amount. Please try again",
    "GAME_LIMIT_REGULATION_ERROR": "The maximum amount is {regulationLimit}. Please try again.",
    "GAME_LIMIT_MIN_BET_ERROR": "Amount below table minimum. Please try again",
    "ADD_FUNDS_TOTAL_BALANCE": "Total balance",
    "ADD_FUNDS_OTHER_AMOUNT": "Other amount",
    "ADD_FUNDS_TOP_UP": "Add Funds",
    "ADD_FUNDS_GAME_HEADER_BUTTON": "Add Funds",
    "ADD_FUNDS_GAME_NAVBAR_BUTTON": "Add Funds",
    "ADD_FUNDS_BLOCKED_TITLE": "Add Funds",
    "ADD_FUNDS_BLOCKED_MESSAGE": "It is not possible to add more funds.\n YOu have reached the limit of 1000€ for this game session",
    "AGE_ACKNOWLEDGE_POPUP_TITLE": "Acknowledgement",
    "AGE_ACKNOWLEDGE_POPUP_MESSAGE": "Persons under the age of 21 are not permitted to engage in interactive gaming.\nPlease confirm that you are over 21 years old",
    "AGE_ACKNOWLEDGE_POPUP_CONFIRM_BUTTON": "Confirm",
    "AGE_ACKNOWLEDGE_POPUP_DECLINE_BUTTON": "Decline",
    "STATE_POPUP_DEFAULT_OPTION": "Select...",
    "STATE_POPUP_NO_STATE_SELECTED": "You must choose a state!",
    "CHOOSE_CONFIRM_STATE": "Please confirm that you're located in",
    "STATE_POPUP_OTHER_STATE": "I don't see my state",
    "STATE_SELECTOR_MENU_ITEM": "State Selector",
    "LUGAS_COOLING_OFF_LOGOUT_MESSAGE": "By logging out you will not be able to play any game for 5:00 mins.",
    "LUGAS_ACTIVE_TITLE": "Notification",
    "LUGAS_ACTIVE_TEXT_1": "It looks like you're currently playing on a different site. Per local regulations, please log out to continue here.",
    "LUGAS_ACTIVE_TEXT_2": "888 receives this information from the German system used to enforce regulations.",
    "LUGAS_COOLDOWN_TITLE": "Please wait",
    "LUGAS_COOLDOWN_TEXT": "According to Germany regulation there’s a five minute cool down period after logging out from another operator.",
    "LUGAS_OK_BTN": "OK",
    "LIVE_ROULETTE": "Live Roulette",
    "LIVE_BLACKJACK": "Live Blackjack",
    "LIVE_BACCARAT": "Live Baccarat",
    "LIVE_POKER": "Live Poker",
    "LIVE_GAME_SHOWS": "Live Game Shows",
    "LIVE_ELITE_LOUNGE": "Live Elite Lounge",
    "JOIN_NOW": "JOIN NOW",
    "Adventure": "Adventure",
    "Ancient Civilization": "Ancient Civilization",
    "Arabic": "Arabic",
    "Asian": "Asian",
    "Classic Style": "Classic Style",
    "Comics and Cartoons": "Comics and Cartoons",
    "Diamonds and Gems": "Diamonds and Gems",
    "Egyptian": "Egyptian",
    "Fantasy and Folklore": "Fantasy and Folklore",
    "Farm and Pets": "Farm and Pets",
    "Fish": "Fish",
    "Fruit and Candy": "Fruit and Candy",
    "Greek Mythology": "Greek Mythology",
    "Irish": "Irish",
    "Money and Leisure": "Money and Leisure",
    "Movies and Music": "Movies and Music",
    "Seasonal": "Seasonal",
    "Space and Sci-fi": "Space and Sci-fi",
    "Wildlife": "Wildlife",
    "GAME_STUDIOS": "Game studios",
    "THEMES": "Themes",
    "GAME_FEATURES": "Features",
    "GAME_CATEGORIES": "Categories",
    "FILTER_BY": "Filter by",
    "NO_JACKPOT": "No Jackpot",
    "HIGH_STAKES": "High Stakes",
    "LOW_STAKES": "Low Stakes",
    "MULTIHAND": "Multihand",
    "MEDIUM_VOLATILITY": "Medium Volatility",
    "VOLATILITY": "Volatility",
    "ONBOARDING_WELCOME_STEP_MAIN_TEXT": "More games. Bigger jackpots. Personalized experience.",
    "ONBOARDING_WELCOME_STEP_SECONDARY_TEXT": "Ready to explore your new home?",
    "ONBOARDING_MENU_STEP_MAIN_TEXT": "This magic menu will take you straight to ALL the fun",
    "ONBOARDING_MENU_STEP_SECONDARY_TEXT": "Jackpots, slots, LIVE tables & promotions",
    "ONBOARDING_USER_AREA_MAIN_TEXT": "Control Your Account In One Place",
    "ONBOARDING_USER_AREA_SECONDARY_TEXT": "Account ID, transaction history, bonus overview & more",
    "NEXT": "Next",
    "DONE": "Done",
    "SPEED_GAMES": "Speed Games",
    "generic_notification_popup_title": "Notification",
    "MDP_INACTIVITY_DISCONNECTED_TEXT": "You have been disconnected due to inactivity.",
    "RICH_USER_NOT_LOGGED_IN": "To view your challenges please log in",
    "CONTROL_CENTER_ONBOARDING_TOOLTIP_TEXT": "Set your limits, see your activity stats, and more in the Control Center!",
    "temp_account_title": "Account Verification",
    "temp_account_days_left": "Days Left",
    "temp_account_upload_btn": "UPLOAD DOCUMENTS",
    "MENU_ITEM_ABOUT": "About",
    "MENU_ITEM_GAMING_SESSION_HISTORY": "Session History",
    "MENU_ITEM_TOUCH_ID": "Biometric Login",
    "MENU_ITEM_INACTIVITY_TIMEOUT_SETTINGS": "Settings",
    "MENU_ITEM_HYBRID_INFO": "Info",
    "MENU_ITEM_CASHIER_VERIFY_ID": "Identity Verification",
    "NJ_JERSEY_COUNTRY_NAME": "NEW JERSEY",
    "FEATURED_GAMES": "Featured Games",
    "LIVE_BACCARAT_BONANZA": "Live Baccarat Bonanza",
    "TOP_HOLLYWOOD_SLOTS": "Top Hollywood slots",
    "THE_WILD_WEST": "The Wild West",
    "TREASURES_OF_EGYPT": "Treasures Of Egypt",
    "GRID_SLOTS": "Grid Slots",
    "SECRETS_OF_THE_GREEK_MYTHOLOGY": "Secrets of the Greek mythology",
    "DIAMONDS_ARE_FOREVER": "Diamonds Are forever",
    "LUCK_OF_THE_IRISH": "Luck of the Irish",
    "LIVE_CASINO_PAGE": "Live Casino page",
    "NEW_LIVE_CASINO_GAMES": "New Live Casino Games",
    "TOP_LIVE_TABLE_GAMES": "Top Live Table Games",
    "ARCADE_GAMES": "Arcade Games",
    "8_HOURS_JACKPOT": "8 hours jackpot",
    "VEGAS_SLOTS": "Vegas Slots",
    "MUSIC_TO_MY_EARS": "Music to my ears",
    "GENIES_JACKPOT": "Genie's Jackpot",
    "BIG_PLAYTECH_JACKPOTS": "Big Playtech Jackpots",
    "ASIAN_GEMS": "Asian Gems",
    "CANDY_SHOP": "Candy Shop",
    "kick_reason_general": "You’ve been logged out.",
    "kick_reason_20": "You’ve been logged out because you signed in from another location.",
    "kick_reason_21": "We have detected that you are \nattempting to login from outside the state of New Jersey. This conduct is in violation of New Jersey state law N.J.S.A 5:12-95.23a. You should immediately cease and desist from attempting to login from outside of New Jersey. We have retained your user information and future attempts could result in an enforcement action.",
    "kick_reason_23": "We are unable to confirm you are \nlocated in the State of New Jersey which is a legal requirement for online wagering. Please check your Wi-Fi card is enabled, please contact customer support so we can help you resolve this problem.",
    "kick_reason_24": "We have detected that you are \naccessing the internet through a proxy, VPN, or other service which has the ability to misrepresent the geographic location of a device. While your use of this service may be inadvertent, we are not able to confirm your location legal requirement for online wagering. Please contact customer support. so we can help you resolve this problem.",
    "kick_reason_25": "We have detected that you are \nattempting to login from outside the state of New Jersey. This conduct is in violation of New Jersey state law N.J.S.A 5:12-95.23a. You should immediately cease and desist from attempting to login from outside of New Jersey. We have retained your user information and future attempts could result in an enforcement action.",
    "kick_reason_26": "We are unable to confirm you are \nlocated in the State of New Jersey which is a legal requirement for online wagering. This appears to be a technical problem. Please contact customer support so we can help you resolve this problem.",
    "kick_reason_27": "To bet we must verify that you are located in {stateName}. Please {downloadPluginLink} and install this plugin that will allow us to verify your location based on your Wi-Fi connection.",
    "kick_reason_28": "To bet on real money we must \nupdate the plugin that enables us to verify your location. Click {installPlugin} to install.",
    "kick_reason_29": "We are unable to confirm you are located in the State of New Jersey which is a legal requirement for online wagering. This appears to be a technical problem. Please contact customer support so we can help you resolve this problem.",
    "kick_reason_30": "You have reached your daily game time limit. Once the time limit expires, you will be able to enjoy our games again.",
    "kick_reason_31": "We are unable to confirm you are located in the State of New Jersey which is a legal requirement for online wagering. This appears to be a technical problem. Please contact customer support so we can help you resolve this problem.",
    "kick_reason_32": "We are unable to confirm you are located in the State of New Jersey which is a legal requirement for online wagering. This appears to be a technical problem. Please contact customer support so we can help you resolve this problem.",
    "kick_reason_33": "Unfortunately the network you are currently connected to does not allow us to verify that you are in New Jersey. Please connect to a different network and try again.",
    "kick_reason_34": "We are unable to confirm you are located in the State of New Jersey which is a legal requirement for online wagering. This appears to be a technical problem. Please contact customer support so we can help you resolve this problem.",
    "kick_reason_35": "According to the New Jersey state regulation we are required to determine your exact location. Please enable your device location services.",
    "kick_reason_36": "Your device is running software \nwhich may be utilized to bypass geolocation checks which are required by New Jersey law. While your use of this software may be inadvertent, we are not able to confirm your location legal requirement for online wagering. Please contact customer support. so we can help you resolve this problem.",
    "kick_reason_50": "The game you are trying to open is currently not available.",
    "kick_reason_51": "According to legal requirements you are required to perform some actions on your account. Please login again to complete them.",
    "kick_reason_live_casino": "We couldn't verify your location. You can finish a game round but not perform an additional bet or game action.",
    "TOUCH_ID_SUB_CAPTION": "This feature will be enabled on your next login",
    "TOUCH_ID_CAPTION": "You can log in faster using the Touch/Face ID features on your device.",
    "TERMS_AND_CONDITIONS": "Terms And Conditions",
    "TOUCH_ID_INIT_SCREEN_ENABLE_BUTTON": "ENABLE NOW",
    "TOUCH_ID_AUTO_SCREEN": "LOGIN WITH TOUCH/FACE ID",
    "TOUCH_ID_INFO": "<li>Enabling Touch/Face ID feature on this device will allow anyone whose fingerprint is saved on this device to gain full access to your 888 account. You should not proceed to set up this feature if any fingerprint in addition to your own are stored on this device.</li><li>By using Touch/Face ID to access your 888 account, you agree that you are solely responsible for all transactions on your account, regardless if such transactions are made by a third party or any person with a fingerprint saved on this device.</li><li>In addition, you agree that the operator of the application and its affiliates (together the \"888 Group\") shall not be liable to you for any consequences arising from using Touch/Face ID to access your 888 account. The 888 Group shall not be held responsible for any loss, liability, damage, expenses or costs incurred through the use of this feature.</li><li>For each 888 application which you have on your device, only one of your accounts can be configured to login with Touch/Face ID at any point in time.</li><li>You will be required to login using your password when Touch/Face ID authentication fails or expires.</li><li>888 Group does not store your fingerprint on its servers and does not handle or support Touch/Face ID technology.</li>",
    "TABLE_GAMES": "Table Games",
    "ARCADE": "Arcade",
    "SPORTS": "Sports",
    "MEXICAN": "Mexican",
    "BINGO": "Bingo",
    "CLASSIC_STYLE_MODERNIZED": "Classic Style Modernized",
    "AZTEC_INCA_MAYAN": "Aztec Inca Mayan",
    "CRIME": "Crime",
    "WILD_WEST": "Wild West",
    "CANDY_AND_SWEETS": "Candy And Sweets",
    "GOLD_MINING": "Gold Mining",
    "VIKINGS_AND_NORDIC_MYTHOLOGY": "Vikings And Nordic Mythology",
    "XMAS": "Xmas",
    "JACKPOT_WIDGET_TITLE": "",
    "LAST_LOGIN_TITLE": "Last login:",
    "SESSION_TIMER_TITLE": "Session time",
    "LIVE_SLOTS": "Live Slots",
    "THE_BOOK_SHELF": "The Book Shelf",
    "LUCKYTAP_GAMES": "LuckyTap Games",
    "TSR_WAGERED_AMOUNT": "Your wagered amount",
    "TSR_SUBTITLE_MALTA": "Stay in control of your game!",
    "TSR_WINNINGS_TEXT": "Your total winnings",
    "TSR_LOSSES_TEXT": "Your total losses",
    "TSR_CLOSE_GAME": "Close game",
    "TSR_TITLE": "Time Spent Reminder",
    "TSR_MENU_LINK_LABEL": "Time Spent Reminder",
    "TSR_CONFIRM": "OK",
    "TSR_SESSION_TIME_TEXT": "You have been logged in for:",
    "EXIT": "Exit",
    "EXIT_GAME_POPUP_TITLE": "exit game",
    "EXIT_GAME_POPUP_TEXT": "Are you sure you want to exit game?",
    "CROSS_POKER_ICON_ALT_TEXT": "Online Poker",
    "OPEN_SESSION_STATUS_LABEL": "Status",
    "OPEN_SESSION_STATUS_PENDING": "Pending",
    "OPEN_BETS": "Open Bets",
    "MIN_BET": "Min",
    "CONTINUE_GAME": "Continue Game",
    "OPEN_BETS_NO_RECORDS": "We were unable to locate any history records of your open games",
    "VIDEO_SLIDES_FILTER_PREVIEW_TITLE": "Explore our categories",
    "VIDEO_SLIDES_LIVE_STREAMING": "LIVE Streaming",
    "VIDEO_SLIDES_ONBOARDING_MAIN_TEXT": "Swipe",
    "VIDEO_SLIDES_ONBOARDING_SECONDARY_TEXT": "To see more games",
    "VIDEO_SLIDES_ERROR_MAIN_TEXT": "Error loading the video. Tap to retry",
    "EXPLORE": "Explore",
    "ONBOARDING_BOTTOM_NAV_BAR_EXPLORE_MAIN_TEXT": "Casino like never before!",
    "ONBOARDING_BOTTOM_NAV_BAR_EXPLORE_SECONDARY_TEXT": "GO EXPLORE",
    "INACTIVITY_TIMEOUT_SETTINGS_TITLE": "Inactivity Timeout Settings",
    "INACTIVITY_TIMEOUT_SETTINGS_MINUTES": "{minutes} MIN.",
    "INACTIVITY_TIMEOUT_SETTINGS_LABEL": "Set the amount of idle time before you are logged out",
    "REALITY_CHECK_DIALOG_SESSION_TIMER_LABEL": "You have been logged in for:",
    "REALITY_CHECK_DIALOG_SESSION_WINNINGS_LABEL": "Your total winnings are:",
    "REALITY_CHECK_DIALOG_SESSION_LOSSES_LABEL": "Your total losses:",
    "REALITY_CHECK_DIALOG_TITLE": "Reminder",
    "REALITY_CHECK_DIALOG_CONTINUE_BUTTON": "Continue",
    "CLOSE_GAME": "Close Game",
    "BONUS_ABUSE_PARKING_MONEY_TITLE": "Bonus Availability",
    "LOGGED_IN_CASHIER_BTN": "Cashier",
    "BONUS_ABUSE_PARKING_MONEY_TEXT_POKER_WITH_REAL_MONEY": "You have an open registration to a future poker tournament that must be completed before your bonus balance becomes available for game play.\n\nIn the meantime,\n•You have {RealMoneyBalance} cash to play with. You can adjust your bet and play now.\n•You can deposit and play with cash. \n\nHow would you like to proceed?",
    "BONUS_ABUSE_PARKING_MONEY_TEXT_POKER_WITHOUT_REAL_MONEY": "You have an open registration to a future poker tournament that must be completed before your bonus balance becomes available for game play.\n\nIn the meantime,\n•You can deposit and play with cash. \n\nHow would you like to proceed?",
    "BONUS_ABUSE_PARKING_MONEY_TEXT_SPORT_WITH_REAL_MONEY": "You have open sports bets that must be settled before your bonus balance becomes available for game play.\n\nIn the meantime,\n•You have {RealMoneyBalance} cash to play with. You can adjust your bet and play now.\n•You can deposit and play with cash. \n\nHow would you like to proceed?",
    "BONUS_ABUSE_PARKING_MONEY_TEXT_SPORT_WITHOUT_REAL_MONEY": "You have open sports bets that must be settled before your bonus balance becomes available for game play.\n\nIn the meantime,\n•You can deposit and play with cash. \n\nHow would you like to proceed?",
    "BONUS_ABUSE_PARKING_MONEY_TEXT_POKER_AND_SPORT_WITH_REAL_MONEY": "You have open cash bets on sport and poker that must be settled before your bonus balance becomes available for game play.\n\nIn the meantime,\n•You have {RealMoneyBalance} cash to play with. You can adjust your bet and play now.\n•You can deposit and play with cash. \n\nHow would you like to proceed?",
    "BONUS_ABUSE_PARKING_MONEY_TEXT_POKER_AND_SPORT_WITHOUT_REAL_MONEY": "You have open cash bets on sport and poker that must be settled before your bonus balance becomes available for game play.\n\nIn the meantime,\n•You can deposit and play with cash. \n\nHow would you like to proceed?",
    "HYBRID_VERSION_MESSAGE_UPGRADE_BUTTON": "Upgrade",
    "HYBRID_VERSION_MESSAGE_NOT_NOW_BUTTON": "Not Now",
    "HYBRID_VERSION_MESSAGE_TITLE": "A new version is available!",
    "HYBRID_VERSION_MESSAGE_BODY": "A newer version of our casino app is available. Upgrade now to enjoy the latest features!",
    "GENERIC_NOTIFICATION_POPUP_TITLE": "Notification",
    "RESTRICTION_FOR_USE_TITLE": "Restricted Country",
    "RESTRICTION_FOR_USE_TEXT": "Due to regulations, this app cannot be used from your country of residence.",
    "INACTIVITY_IDLE_POPUP_TEXT": "Due to inactivity, you will be disconnected in {timer} minutes.\n Click OK to continue playing.",
    "HYBRID_VERSION_NOT_AVAILABLE_TITLE": "INFO",
    "HYBRID_VERSION_NOT_AVAILABLE": "Play on the new Ontario app. \n There's a new app dedicated for Ontario players!",
    "HYBRID_VERSION_NOT_AVAILABLE_DOWNLOAD": "GET THE APP",
    "NIGHT_LIMIT_TITLE": "Safer Gambling Message",
    "NIGHT_LIMIT_SOFT_KICK_TEXT": "We see that your activity hasn't slowed down. Please understand we are committed to ensuring your experience here is not just fun but also safe. \n\nA temporary restriction has been placed on your account so you will not be able to continue playing for the next {hours} hours.\n\nWe've sent you an email with more information about the restriction and the available responsible gaming tools and controls.",
    "NIGHT_LIMIT_CTA": "GOT IT",
    "NIGHT_LIMIT_OPEN_GAME_TEXT": "The temporary restriction is still active and will be removed on {date} starting from {hour}.",
    "UK_LICENSE_STATUS": "Licensed status",
    "UK_LICENSE_TEXT": `Copyright 2024, the 888 Group. All rights reserved.
    888 Holdings plc is listed on the London Stock Exchange.
    Virtual Global Digital Services Limited and VDSL (International) Limited are licensed and regulated to offer online gaming services under the laws of Gibraltar (Remote Gaming License Numbers 112 and 113) and make no representation as to legality of such services in other jurisdictions.
    In the event that you have registered from Canada, our services are provided by VDSL (International) Limited.
    Our services in the UK are operated by 888 UK Limited, a company incorporated in Gibraltar. 888 UK Limited is licensed and regulated in Great Britain by the #UK-LICENSE-PAGE-LINK# under the account number 39028.
    Our services in European Single Market member states (except for states in which our services are provided under a local license) are operated by Virtual Digital Services Limited, a company incorporated in Malta which is part of the European Union.
    Virtual Digital Services Limited operates under the auspices of a gaming license provided under the laws of Malta - MGA/CRP/543/2018 issued on the 11/10/2019.
    Our betting products are operated in Ireland by 888 (Ireland) Limited, a company incorporated in Malta, which is licensed and regulated by Ireland's Revenue Commissioners.
    The address of our Gibraltar based companies is: 601-701 Europort, Gibraltar.
    The address of our Malta based companies is: Level 7, Tagliaferro Business Centre, 14, High Street, Sliema SLM 1549, Malta
    Gambling can be addictive, please play responsibly. For more information on support tools, please visit our #UK-LICENSE-PAGE-LINK#`,
    "UK_LICENSE_GC_PAGE_LINK": "Gambling Commission",
    "UK_LICENSE_RG_PAGE_LINK": "Responsible Gambling Page",
    "EXPLORER_BADGE_NEW": "NEW",
    "EXPLORER_NOT_AVAILABLE_TITLE": "Stay Tuned!",
    "EXPLORER_NOT_AVAILABLE_TEXT": "Thanks for checking this out! This feature is being gradually introduced on mobile, so it might not be available to everyone just yet. Keep an eye out for updates!",
    "JACKPOT_BET_WINNERS": "Winners Today",
    "JACKPOT_BET_CONTRIBUTION": "Contribution",
    "JACKPOT_BET": "Jackpot bet",
    "JOIN_JACKPOT_BET": "Join the pot",
    "PLAY_WITHOUT_JACKPOT_BET": "Play without joining",
    "daily_jackpot_drop_toaster_title": "Today's {jackpotAmount} Daily Jackpot just dropped!",
    "daily_jackpot_threshold_toaster_title": "The Daily Jackpot",
    "twilight_jackpot_drop_toaster_title": "Today's {jackpotAmount} Twilight Jackpot just dropped!",
    "twilight_jackpot_threshold_toaster_title": "The Twilight Jackpot",
    "jackpot_drop_toaster_text": "Didn't win? No worries! Within 24 hours, another jackpot will drop.",
    "game_item_play_btn": "Play",
    "jackpot_amount_threshold_text_template1": "The jackpot has passed {currencySymbol}{jackpotThreshold}.",
    "jackpot_amount_threshold_text_template2": "The jackpot is at {currencySymbol}{jackpotThreshold} and rising.",
    "jackpot_amount_threshold_text_template3": "The jackpot has now surpassed {currencySymbol}{jackpotThreshold} and is still progressing.",
    "jackpot_amount_threshold_text_template4": "The jackpot is over {currencySymbol}{jackpotThreshold} and still progressing.",
    "jackpot_amount_threshold_text_template5": "The jackpot has reached {currencySymbol}{jackpotThreshold}.",
    "jackpot_amount_threshold_text_template6": "The jackpot is at {currencySymbol}{jackpotThreshold} and is still moving upward.",
    "jackpot_amount_threshold_text_template7": "The jackpot has just reached {currencySymbol}{jackpotThreshold} and is still rising.",
    "progressive_jackpot_threshold_toaster_title": "The {gameName} Jackpot",
    "red_tiger_jackpot_threshold_toaster_title": "The Red Tiger Daily Jackpot",
    "INTERVAL_REMINDER_BODY": "You are playing for {hours} hours and {minutes} minutes. Good luck!",
    "INTERVAL_REMINDER_TITLE": "Reminder",
    "JACKPOT_BETS_REMINDER_BODY": "You've opted-in to the 888jackpot Hunt! You will now be charged {jackpotBetContribution} per round on top of your normal bet.",
    "BIOMETRIC_LOGIN": "Biometric Login",
    "BIOMETRIC_LOGIN_INFO": "You can log in faster using the touch/face ID features on your device.",
    "SETTINGS": "Settings",
    "LANGUAGE": "Language",
    "LANGUAGES_COUNTRY_CHOOSE_INFO": "Choose your language or country.",
    "JACKPOT_BETS_ERROR_TOASTER_TITLE": "888jackpot Hunt",
    "JACKPOT_BET_ERROR_TOASTER_BODY_REASON_3": "You were not charged during your last round as your bet was below the limit stated in the T&C's.",
    "JACKPOT_BET_ERROR_TOASTER_BODY_REASON_5": "Pending translation for jp bet error reason 5",
    "JACKPOT_BET_ERROR_TOASTER_BODY_REASON_13": "Pending translation for jp bet error reason 13",
    "JACKPOT_BET_ERROR_TOASTER_BODY_REASON_GENERAL": "Pending translation for jp bet general error",
    "JACKPOT_BETS_ERROR_TOASTER_CTA_TEXT": "OPT-OUT",
    "ROTATE_DEVICE_TO_PORTRAIT": "Please rotate your device in portrait mode"
  }
}